(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bsm-product-banners"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bsm-product-banners')) {
  customElements.define('bsm-product-banners', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('[data-banner-track]');
      this.slides = [...this.querySelectorAll('[data-banner-slide]')];
      this.dots = [...this.querySelectorAll('[data-banner-dot]')];
      this.toggle = this.querySelector('[data-banner-toggle]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.current = 0;
      this.playing = this.dataset.autoplay === 'true' && !window.Shopify?.designMode;
      this.querySelector('[data-banner-controls]').hidden = this.slides.length < 2;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-banner-toggle')) {
          this.playing = !this.playing;
          this.update();
          return;
        }
        if (button.hasAttribute('data-banner-next')) this.go(this.current + 1);
        else if (button.hasAttribute('data-banner-previous')) this.go(this.current - 1);
        else if (button.hasAttribute('data-banner-dot')) this.go(Number(button.dataset.bannerDot));
      }, options);
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.go(this.current + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.settle);
        this.settle = setTimeout(() => {
          this.current = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / this.track.clientWidth)));
          this.update();
        }, 120);
      }, { ...options, passive: true });
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => this.update(), options);
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) { this.stop(); this.go(index, true); }
      }, options);
      this.resize = new ResizeObserver(() => {
        this.track.scrollTo({ left: this.current * this.track.clientWidth, behavior: 'instant' });
      });
      this.resize.observe(this.track);
      this.update();
    }
    stop() {
      this.playing = false;
      this.update();
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.playing || document.hidden || this.slides.length < 2) return;
      this.timer = setTimeout(() => this.go(this.current + 1), Number(this.dataset.interval) || 4000);
    }
    go(index, instant = false) {
      const wrapped = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left: wrapped * this.track.clientWidth, behavior: instant || this.motion.matches || index !== wrapped ? 'instant' : 'smooth' });
    }
    update() {
      const dotStart = Math.max(0, Math.min(this.current - 2, this.dots.length - 5));
      this.slides.forEach((slide, index) => {
        slide.inert = index !== this.current;
        slide.setAttribute('aria-hidden', String(index !== this.current));
        this.dots[index].hidden = this.dots.length > 5 && (index < dotStart || index >= dotStart + 5);
        this.dots[index].setAttribute('aria-pressed', String(index === this.current));
      });
      this.querySelector('[data-banner-current]').textContent = String(this.current + 1);
      this.toggle.setAttribute('aria-label', this.playing ? this.dataset.pauseLabel : this.dataset.playLabel);
      this.querySelector('[data-banner-pause-icon]').toggleAttribute('hidden', !this.playing);
      this.querySelector('[data-banner-play-icon]').toggleAttribute('hidden', this.playing);
      this.toggle.hidden = false;
      this.track.setAttribute('aria-live', this.playing ? 'off' : 'polite');
      this.schedule();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      clearTimeout(this.timer);
      clearTimeout(this.settle);
      this.resize?.disconnect();
    }
  });
}
if (!customElements.get('bsm-banner-video')) {
  customElements.define('bsm-banner-video', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.desktop = matchMedia('(min-width: 1001px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const options = { signal: this.abort.signal };
      this.desktop.addEventListener('change', () => this.sync(), options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.video?.pause();
      }, options);
      this.sync();
    }
    sync() {
      if (!this.desktop.matches) {
        this.unload();
        return;
      }
      if (this.video) return;
      this.append(this.querySelector('template').content.cloneNode(true));
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.video.muted = true;
      this.video.preload = 'metadata';
      if (this.dataset.autoplay === 'true' && !this.motion.matches) {
        this.video.play().catch(() => {});
      }
    }
    unload() {
      if (!this.video) return;
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
      this.video.load();
      this.video.remove();
      this.video = null;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.unload();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
